import { render, staticRenderFns } from "./trainingModuleQuestion.vue?vue&type=template&id=1673803a&scoped=true&"
import script from "./trainingModuleQuestion.vue?vue&type=script&lang=js&"
export * from "./trainingModuleQuestion.vue?vue&type=script&lang=js&"
import style0 from "./trainingModuleQuestion.vue?vue&type=style&index=0&id=1673803a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1673803a",
  null
  
)

export default component.exports